<template>
  <v-overlay
    class="overlay"
    :value="overlay"
    :hide-overlay="false"
    :persistent="false"
    :retain-focus="true"
    :aria-hidden="false"
  >
    <v-progress-circular
      color="primary"
      indeterminate
      size="64"
      role="progressbar"
      aria-label="Loading"
    ></v-progress-circular>
  </v-overlay>
</template>

<script>
export default {
  props: {
    overlay: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    overlay(newVal) {
      if (newVal) {
        // Store current focus when overlay opens
        this.previousFocus = document.activeElement;
      } else {
        // Restore focus when overlay closes
        if (this.previousFocus && this.previousFocus.focus) {
          this.previousFocus.focus();
        }
      }
    },
  },
  data() {
    return {
      previousFocus: null,
    };
  },
};
</script>

<style></style>
